import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-964c2bc6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "lecture-container"
};
const _hoisted_2 = {
  class: "link-list"
};
const _hoisted_3 = {
  class: "text"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "更多", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu"
}, null, -1));

import CardHeader from '@/pages/components/CardHeader.vue';
import LectureCard from './LectureCard.vue';
export default {
  props: {
    menu: Object
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    const lectureList = ref([]);
    const pageInfo = reactive({
      pageNum: 1,
      pageSize: 8,
      total: 0
    });

    const getLectureList = async () => {
      const res = await $http.getLectureList({
        menu_id: props.menu.menu_id,
        start_time_sort: 2,
        '_pageable.page': pageInfo.pageNum - 1,
        '_pageable.size': pageInfo.pageSize,
        live_status: 2
      });
      console.log('培训研讨', res);
      lectureList.value = res.content || [];
    };

    getLectureList();
    return (_ctx, _cache) => {
      return lectureList.value && lectureList.value.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "lecture-wrapper",
        style: _normalizeStyle({
          backgroundColor: __props.menu.backColor,
          backgroundImage: `url(${__props.menu.backImage})`
        })
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(CardHeader, {
        link: `/lectureList.html?name=${__props.menu.module_name}&menuId=${__props.menu.menu_id}`
      }, {
        left: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(__props.menu.module_name), 1)])]),
        right: _withCtx(() => [_hoisted_4, _hoisted_5]),
        _: 1
      }, 8, ["link"]), _createElementVNode("div", {
        class: _normalizeClass(["lecture-content", {
          'one-lecture-content': lectureList.value.length == 1
        }])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lectureList.value.slice(0, 2), (item, index) => {
        return _openBlock(), _createBlock(LectureCard, {
          key: index,
          index: index,
          lectureCount: lectureList.value.length,
          lectureData: item,
          menu: __props.menu
        }, null, 8, ["index", "lectureCount", "lectureData", "menu"]);
      }), 128))], 2)])], 4)) : _createCommentVNode("", true);
    };
  }

};